// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const setSelectedPortfolio = value => ({
    type: actionTypes.RA_GLOBAL_POSITION_SET_SELECTED_PORTFOLIO,
    payload: {
        value,
    },
});

const setOriginRedirection = (origin, id = '') => ({
    type: actionTypes.RA_GLOBAL_POSITION_SET_ORIGIN_REDIRECTION,
    payload: {
        origin,
        id,
    },
});

const requestSaveSimulationLandingMessage = value => ({
    type: actionTypes.RA_GLOBAL_POSITION_GET_SAVE_SIMULATION_MESSAGE,
    payload: {
        value,
    },
});

const setSinglePortfolioNotificationClosed = value => ({
    type: actionTypes.RA_GLOBAL_POSITION_SET_ROBO_TRANSFER_NOTIFICATION_CLOSED,
    payload: {
        value,
    },
});

const disabledNotificationSuccess = data => ({
    type: actionTypes.RA_GLOBAL_POSITION_DISABLED_NOTIFICATION_SUCCESS,
    payload: {
        data,
    },
});

const disabledNotificationFailed = error => ({
    type: actionTypes.RA_GLOBAL_POSITION_DISABLED_NOTIFICATION_FAILED,
    payload: {
        error,
    },
});

const setSinglePortfolioNotificationDisabled = portfolioId => dispatch => {
    const params = {
        portfolioId,
    };

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('raPortfolioDisableWidget', params),
    )
        .then(response => {
            dispatch(disabledNotificationSuccess(response));
        })
        .catch(error => {
            dispatch(disabledNotificationFailed(error));
        });
};

module.exports = {
    requestSaveSimulationLandingMessage,
    setSelectedPortfolio,
    setSinglePortfolioNotificationClosed,
    setSinglePortfolioNotificationDisabled,
    setOriginRedirection,
};
